import './devextreme-license';
import {
    enableProdMode,
    Injector,
    APP_INITIALIZER,
    LOCALE_ID,
    DEFAULT_CURRENCY_CODE,
    importProvidersFrom,
    provideZoneChangeDetection,
} from '@angular/core';
import { environment } from './environments/environment';
import { getRemoteServiceBaseUrl, appInitializerFactory, getCurrencyCode, getCurrentLanguage } from './root.module';
import { API_BASE_URL } from '@shared/service-proxies/service-proxies';
import { PlatformLocation } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppModule } from './app/app.module';
import { VcpmsCommonModule } from '@shared/common/common.module';
import { ServiceProxyModule } from '@shared/service-proxies/service-proxy.module';
import { withInterceptorsFromDi, provideHttpClient, withJsonpSupport } from '@angular/common/http';
import { TitleStrategy } from '@angular/router';
import { RootRoutingModule } from './root-routing.module';
import { RootComponent } from './root.component';
import { AppPageTitleStrategy } from '@shared/common/page-title/app-page-title.strategy';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';

if (environment.production) {
    enableProdMode();
}

const bootstrap = () =>
    bootstrapApplication(RootComponent, {
        providers: [
            importProvidersFrom(
                BrowserModule,
                AppModule,
                VcpmsCommonModule.forRoot(),
                ServiceProxyModule,
                RootRoutingModule,
                NgxSpinnerModule
            ),
            { provide: API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            // Dynamic browser tab title per route (Requirement #5506). Declared after
            // importProvidersFrom(RootRoutingModule) so it overrides the router's default.
            { provide: TitleStrategy, useClass: AppPageTitleStrategy },
            {
                provide: APP_INITIALIZER,
                useFactory: appInitializerFactory,
                deps: [Injector, PlatformLocation],
                multi: true,
            },
            {
                provide: LOCALE_ID,
                useFactory: getCurrentLanguage,
            },
            {
                provide: DEFAULT_CURRENCY_CODE,
                useFactory: getCurrencyCode,
                deps: [Injector],
            },
            provideZoneChangeDetection({ eventCoalescing: true }),
            provideAnimations(),
            // Single application-wide HttpClient registration. NgModules must NOT also import
            // HttpClientModule — doing so double-registers the HTTP_INTERCEPTORS chain and
            // triggers NG0200 (circular dependency on HTTP_INTERCEPTORS) under Angular 17+.
            // withInterceptorsFromDi() preserves the legacy class-based HTTP_INTERCEPTORS
            // providers (ZeroTemplateHttpInterceptor, ShellResponseCacheInterceptor);
            // withJsonpSupport() replaces the removed HttpClientJsonpModule.
            provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
            provideAnimationsAsync(),
            providePrimeNG({
                theme: {
                    preset: Lara,
                    options: {
                        darkModeSelector: '[data-bs-theme="dark"]',
                    },
                },
            }),
        ],
    });

bootstrap();
